import { styled } from '@aibi-ui/core';
import React from 'react';

const ConversationsContainer = styled.div`
  overflow: hidden;
  height: auto;
  background: #f3f4f6;
  border: 1px solid #e8e8e8;
  border-radius: 0 6px 0 0;
  transition: width 0.2s ease;
`;
const AsideContainer: React.FC<React.HTMLAttributes<HTMLDivElement> & {}> = ({
  children,
  ...props
}) => {
  return <ConversationsContainer {...props}>{children}</ConversationsContainer>;
};
export default AsideContainer;
